import {ReportButton} from '../components/reportButton.js';

/**
 * Initialize all report buttons on the page.
 * Follows the same pattern as bookmarks.js for consistency.
 *
 * @param {Document|Element} container - The container to search for report buttons. Defaults to document.
 */
export function initReportButtons(container = document) {
    const reportButtons = container.querySelectorAll('.js-reportButton:not([data-report-initialized])');

    reportButtons.forEach((button) => {
        new ReportButton(button);
        button.dataset.reportInitialized = 'true';
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initReportButtons());
} else {
    initReportButtons();
}
